// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"feb56ff2","647":"b370bac1"}[chunkId] + ".chunk.js";
};